// extracted by mini-css-extract-plugin
export var bodyRow = "_f7-d";
export var cardColumns = "_f7-e";
export var ellipsesOverflow = "_f7-2";
export var flatBottomCorners = "_f7-3";
export var flatTopCorners = "_f7-4";
export var headerActionsDropdown = "_f7-f";
export var headerBottomRow = "_f7-c";
export var headerTopRow = "_f7-b";
export var orderDetailsWrapper = "_f7-0";
export var orderInfoContainer = "_f7-1";
export var productDetails = "_f7-9";
export var productImage = "_f7-5";
export var responsiveTable = "_f7-8";
export var shipmentContainer = "_f7-a";
export var tableBottomLeft = "_f7-6";
export var tableBottomRight = "_f7-7";